<div class="product-card">
  <div class="product-card-image">
    <img
      *ngIf="product?.extra?.images?.length > 0"
      [src]="product.extra.images[0].s3Uri
        | gungImageUrl
          :'type:detail'
          :'orientation:portrait'
          :'etag:'+product.extra.images[0].s3ETag
      "
      alt="{{ product.extra.images[0].description }}"
    />
  </div>

  <div class="product-card-body">
    <span class="product-id">{{ product.extra?.gme?.displayId || product.id }}</span>
    <h4 class="product-name">{{ product.extra?.gme?.displayName || product.name }}</h4>
    <p class="product-description" *ngIf="product.description">{{ product.description }}</p>
  </div>

  <div class="product-card-meta" *ngIf="product.productType !== 'concept'">
    <div class="product-price" *ngIf="price">
      <lib-price
        [price]="price"
        type="GROSS"
        [currency]="price.customerNetPrice.currencyCode"
        [product]="product"
      ></lib-price>
      <span class="discount-badge" *ngIf="price.customerDiscountAmount?.value > 0">
        -{{ price.customerDiscountPercent | number: '1.0-1' }}%
      </span>
    </div>
    <div class="product-rrp text-muted" *ngIf="price?.recommendedRetailPrice">
      {{ 'RRP' | translate }}
      <lib-price
        [price]="price"
        type="RRP"
        [currency]="price.customerNetPrice.currencyCode"
        [product]="product"
      ></lib-price>
    </div>
    <lib-availability *ngIf="flow?.useAvailabilities && availability" [availability]="availability" [isSales]="isSales" [product]="product"></lib-availability>
  </div>
</div>
